module.exports = __webpack_public_path__ + "img/4-low.887561fe.jpg";